import { useQuery } from '@tanstack/react-query';

import { fetchCarrierInformationSettings } from '../data-provider/settings';
import type { GetCarrierInformationSettingsRequestParams } from '../data-provider/settings/api';

export const useGetCarrierInformationSettings = ({
  companyId,
  ...params
}: GetCarrierInformationSettingsRequestParams & { companyId: number }) => {
  return useQuery({
    enabled: Boolean(params.carrierKey),
    queryFn: () => fetchCarrierInformationSettings(params),
    queryKey: ['claims-carrier-information-settings', companyId, params.carrierKey],
  });
};
